import {
  EventDetailsInterface,
  EventEnrollNextStatus,
  EventEntryEnroll,
  EventListInterface,
} from '@elearning-platform/api-types/interfaces';

import { api } from '../api';

export const getEventList: () => Promise<EventListInterface> = (): Promise<EventListInterface> => api.get('v1/events');

export const disenrollEvent: (id: number) => Promise<void> = (id: number): Promise<void> => api.post(`v1/events/${id}/disenroll`);

export const getEventDetails: (id: number) => Promise<EventDetailsInterface>
= (id: number): Promise<EventDetailsInterface> => api.get(`v1/events/${id}`);

export const enrollEvent: (id: number, data: EventEntryEnroll) => Promise<EventEnrollNextStatus>
= (id: number, data: EventEntryEnroll): Promise<EventEnrollNextStatus> => api.post(`v1/events/${id}/enroll`, data);
